import { makeObservable, observable, action } from "mobx";
import { post } from "../common/requester";
import BaseModel from "./../models/BaseModel";

export default class CompanySearchStore extends BaseModel {
  constructor(store) {
    super(store);
    makeObservable(this, {
      countries: observable,
      regions: observable,
      districts: observable,
      companies: observable,

      getCountries: action,
      getRegions: action,
      getDistricts: action,
      searchCompanies: action,
    });
  }

  countries = [];
  regions = [];
  districts = [];
  companies = [];

  async getCountries() {
    const ret = await post("countries", {}).catch(console.error);
    if (ret?.result === 0) {
      this.countries = ret.countries || [];
    }
    return ret;
  }

  async getRegions(country_id) {
    const ret = await post("regions", { country_id }).catch(console.error);
    if (ret?.result === 0) {
      this.regions = ret.regions || [];
    }
    return ret;
  }

  async getDistricts(region_id) {
    const ret = await post("districts", { region_id }).catch(console.error);
    if (ret?.result === 0) {
      this.districts = ret.districts || [];
    }
    return ret;
  }

  async searchCompanies({ name, sport_id, country_id, region_id, district_id }) {
    const ret = await post("search_companies_dropdown", {
      name,
      sport_id,
      country_id,
      region_id,
      district_id,
    }).catch(console.error);

    if (ret?.result === 0) {
      this.companies = ret.companies || [];
    }

    return ret;
  }
}